export const FUNDING_TYPE_REQUIRED = 'FUNDING_REQUIRED';
export const FUNDING_TYPE_AVAILABLE = 'FUNDS_AVAILABLE';
